














































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import LikertScale from '@/components/common/inputs/LikertScale.vue';
import InfoTooltip from '@/components/common/InfoTooltip.vue';
import FormSection from '@/components/details/FormSection.vue';
import { ProcessState, ProcessModule } from '@/store/modules/process';
import { PhaseKeys, Phase } from '@/models/phase';
import { ErrorModule } from '@/store/modules/error';

@Component({
  components: {
    LikertScale,
    InfoTooltip,
    FormSection
  }
})
export default class AssessmentForm extends Vue {
  PhaseKeys = PhaseKeys;

  get state() {
    return ProcessModule;
  }

  update(state: Partial<ProcessState>) {
    ProcessModule.update(state);
  }

  isInErrors(name: string) {
    return ErrorModule.errorInField(ErrorModule.assessment, name);
  }
}
